import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetInviteFriendCommissionHistory from '@/modules/promotion/api/hooks/useQueryGetInviteFriendCommissionHistory'
import InviteFriendCommissionHistoryListing from '@/modules/promotion/components/InviteFriendCommissionHistory/components/InviteFriendCommissionHistoryListing'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { parseAsBoolean, parseAsString, useQueryState } from 'nuqs'
import { InviteFriendCommissionType } from '@/modules/promotion/type'

function InviteFriendCommissionHistoryPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter } = useDateFilter()
	const [greaterThanZero] = useQueryState(
		'greaterThanZero',
		parseAsBoolean.withOptions({ shallow: false }).withDefault(true),
	)
	const [commissionType] = useQueryState(
		'commissionType',
		parseAsString.withOptions({ shallow: false }),
	)

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		minimumAmount: greaterThanZero ? 0 : undefined,
		commissionType: (commissionType as InviteFriendCommissionType) || undefined,
	}

	const { data, isLoading } = useQueryGetInviteFriendCommissionHistory(payload)

	return (
		<PageContainer>
			<InviteFriendCommissionHistoryListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedInviteFriendCommissionHistoryPage = withUserPermission(
	InviteFriendCommissionHistoryPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_INVITE],
	},
)

export default GuardedInviteFriendCommissionHistoryPage
